import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { addPlace, deletePlace, listPlaces, updatePlace } from '../../shared/api/places'
import type { CreatePlaceInput, UpdatePlaceInput } from '../../shared/api/types'
import { pointKeys } from '../timeline/usePoints'

export const placeKeys = { byTrip: (id: string) => ['places', id] as const }
export function usePlaces(tripId: string | undefined) {
  return useQuery({ queryKey: placeKeys.byTrip(tripId ?? 'unknown'),
    queryFn: () => listPlaces(tripId as string), enabled: Boolean(tripId) })
}
export function useAddPlace(tripId: string) {
  const qc = useQueryClient()
  return useMutation({ mutationFn: (input: CreatePlaceInput) => addPlace(tripId, input),
    onSuccess: () => qc.invalidateQueries({ queryKey: placeKeys.byTrip(tripId) }) })
}
export function useUpdatePlace(tripId: string) {
  const qc = useQueryClient()
  return useMutation({ mutationFn: ({ id, patch }: { id: string; patch: UpdatePlaceInput }) => updatePlace(tripId, id, patch),
    onSuccess: () => { qc.invalidateQueries({ queryKey: placeKeys.byTrip(tripId) }); qc.invalidateQueries({ queryKey: pointKeys.byTrip(tripId) }) } })
}
export function useDeletePlace(tripId: string) {
  const qc = useQueryClient()
  return useMutation({ mutationFn: (id: string) => deletePlace(tripId, id),
    onSuccess: () => { qc.invalidateQueries({ queryKey: placeKeys.byTrip(tripId) }); qc.invalidateQueries({ queryKey: pointKeys.byTrip(tripId) }) } })
}
